import React, { useCallback } from 'react';
import { createCartSlice } from '../store/slice/cartSlice';

export default function Cart() {
  // Only select what we need and memoize the functions
  const cart = createCartSlice((state) => state.cart);
  const clearCart = createCartSlice((state) => state.clearCart);
  
  const removeFromCart = useCallback((productId) => {
    createCartSlice.getState().removeFromCart(productId);
  }, []);
  
  const addToCart = useCallback((product) => {
    createCartSlice.getState().addToCart(product);
  }, []);

  const total = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0).toFixed(2);

  if (cart.length === 0) {
    return (
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center">
          <div className="mb-6">
            {/* You might want to add an actual shopping cart icon here */}
            <span className="text-6xl">🛒</span>
          </div>
          <h2 className="text-3xl font-semibold mb-4 text-gray-800">Your cart is empty</h2>
          <p className="text-gray-600 mb-8">Looks like you haven't added anything to your cart yet.</p>
          <a
            href="/products"
            className="mt-6 inline-block bg-black text-white px-8 py-3 rounded-md hover:bg-gray-800 transition"
          > 
            Browse Products
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="bg-gradient-to-r from-gray-700 to-slate-800 text-white p-6 rounded-lg flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-semibold">Shopping Cart</h2>
          <p className="text-sm mt-1 text-gray-200">{cart.length} items in your cart</p>
        </div>
        <button 
          onClick={clearCart}
          className="bg-white/20 px-4 py-2 rounded-lg hover:bg-white/30 transition"
        >
          Clear cart
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-8 space-y-6">
          {cart.map((item) => (
            <div key={item.id} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition">
              <div className="flex gap-6">
                <div className="flex-grow">
                  <div className="flex items-center gap-4">
                    <img src={item.images[0]} alt={item.name} className="w-20 h-20 object-cover rounded-lg" />
                    <h3 className="text-xl font-semibold text-gray-800">{item.name}</h3>
                  </div>
                  <div className="flex items-center justify-between mt-6">
                    <div className="flex items-center space-x-3">
                      <button 
                        onClick={() => removeFromCart(item.id)} 
                        className="w-9 h-9 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 transition"
                      >
                        -
                      </button>
                      <span className="w-12 text-center font-medium">{item.quantity}</span>
                      <button 
                        onClick={() => addToCart(item)}
                        className="w-9 h-9 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 transition"
                      >
                        +
                      </button>
                    </div>
                    <div className="flex items-center gap-4">
                      <button 
                        onClick={() => removeFromCart(item.id)}
                        className="text-red-500 hover:text-red-600 transition"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end justify-between">
                  <span className="text-lg font-semibold">${(item.price * item.quantity).toFixed(2)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:col-span-4">
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Order Summary</h3>
            <div className="flex justify-between mb-2">
              <span>Subtotal</span>
              <span>${total}</span>
            </div>
            <button className="w-full bg-blue-600 text-white py-2 rounded-lg mt-4 hover:bg-blue-700 transition">
              Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
